import { ErrorBoundary } from '@zenbusiness/application-commons-logging';
import PageError from '@zenbusiness/zui/PageError';
import PageLoading from '@zenbusiness/zui/PageLoading';

import { NAME } from '#client/build-env';
import { ACCOUNT_TYPES } from '#client/constants/accountTypes';
import { useAccountExperience } from '#client/hooks/useAccountExperience';
import { EnterpriseHome, HomeGateway } from '#client/pages';

function CustomerRouterInner() {
  const { accountExperience, loading } = useAccountExperience();
  const isEnterprise = accountExperience.accountType === ACCOUNT_TYPES.ENTERPRISE;

  if (loading) {
    return <PageLoading />;
  }

  if (isEnterprise) {
    return <EnterpriseHome />;
  }

  return <HomeGateway />;
}

export default function CustomerRouter() {
  return (
    <ErrorBoundary fallback={<PageError />} id={`${NAME}/App/CustomerRouter`}>
      <CustomerRouterInner />
    </ErrorBoundary>
  );
}
